import { format } from "date-fns"

// 👉 isEmptyCheckLocal
export const isEmptyCheckLocal = ( value: unknown ): boolean => {
    if ( value === null || value === undefined || value === '' ) return true

    return !!( Array.isArray( value ) && value.length === 0 )
}
// 👉 IsNullOrUndefined
export function isNullOrUndefinedLocal ( value: unknown ): boolean {
    return value === null || value === undefined
}

// 👉 IsEmptyArray
export const isEmptyArrayLocal = ( arr: unknown ): boolean => {
    return Array.isArray( arr ) && arr.length === 0
}

// 👉 IsObject
export const isObjectLocal = ( obj: unknown ): obj is Record<string, unknown> =>
    obj !== null && !!obj && typeof obj === 'object' && !Array.isArray( obj )


export function currentTS (): string {
    return format( new Date(), 'yyyyMMddHHmmss' )
}

export function fixDecimal ( input: string | number, decimals: number = 5 ) {
    const num = +( input ?? 0 )
    return parseFloat( num.toFixed( decimals ) )
}

